export enum Token {
    TOKEN,
}
